/* Only merge CSS if running webpack */
import 'react-datepicker/dist/react-datepicker.css';
import './datePickerOverrides.old.css'; // todo gl2025: remove
import './datePickerOverrides.css';
// eslint-disable-next-line import/extensions
import PortalDatePicker from './PortalDatePicker.js';
export default PortalDatePicker;
